import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, Fragment as _Fragment, createBlock as _createBlock, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "body",
  class: "template_estate-detail"
}
const _hoisted_2 = ["content"]
const _hoisted_3 = ["content"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("meta", {
  property: "og:type",
  content: "product"
}, null, -1)
const _hoisted_5 = ["content"]
const _hoisted_6 = ["content"]
const _hoisted_7 = ["content"]
const _hoisted_8 = ["content"]
const _hoisted_9 = ["content"]
const _hoisted_10 = {
  class: "header-top",
  ref: "headerTop"
}
const _hoisted_11 = { class: "width-wrap" }
const _hoisted_12 = { class: "estate-detail__header-info" }
const _hoisted_13 = { class: "header-line-1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "sep" }, "|", -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "sep" }, "|", -1)
const _hoisted_17 = {
  key: 0,
  class: "header-line-2"
}
const _hoisted_18 = {
  key: 0,
  class: "estate-detail__header-logo"
}
const _hoisted_19 = {
  key: 1,
  class: "estate-detail__header-contact"
}
const _hoisted_20 = { class: "contact-person contact-person--inline" }
const _hoisted_21 = { class: "contact-person__photo" }
const _hoisted_22 = { class: "contact-person__info" }
const _hoisted_23 = { class: "contact-person__name" }
const _hoisted_24 = {
  key: 0,
  class: "contact-person__logo"
}
const _hoisted_25 = { class: "estate-detail__photos" }
const _hoisted_26 = { class: "width-wrap" }
const _hoisted_27 = { class: "gallery-wrap" }
const _hoisted_28 = {
  key: 0,
  class: "estate-likebar"
}
const _hoisted_29 = { class: "estate-detail__main-section section has-aside" }
const _hoisted_30 = { class: "width-wrap" }
const _hoisted_31 = { class: "section-content" }
const _hoisted_32 = { class: "estate-detail-description" }
const _hoisted_33 = { class: "section-aside" }
const _hoisted_34 = {
  key: 0,
  class: "estate-toolbar"
}
const _hoisted_35 = {
  key: 1,
  class: "content-box",
  id: "watchdog-settings"
}
const _hoisted_36 = { class: "checkbox-switch" }
const _hoisted_37 = ["checked"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)
const _hoisted_39 = { class: "check-label theme-dark" }
const _hoisted_40 = {
  key: 2,
  class: "estate-web"
}
const _hoisted_41 = ["href", "rel"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "icon-play" }, null, -1)
const _hoisted_43 = {
  key: 5,
  class: "estate-detail__estate-logo"
}
const _hoisted_44 = { style: {"margin-top":"27px"} }
const _hoisted_45 = {
  key: 0,
  class: "estate-detail__contact-section-login section section--gray has-aside"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { id: "contact-form-section" }, null, -1)
const _hoisted_47 = { class: "section-header" }
const _hoisted_48 = { class: "width-wrap" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_51 = ["href"]
const _hoisted_52 = { class: "buttons-inline" }
const _hoisted_53 = ["href"]
const _hoisted_54 = ["href"]
const _hoisted_55 = ["innerHTML"]
const _hoisted_56 = { class: "width-wrap" }
const _hoisted_57 = { class: "section-content" }
const _hoisted_58 = { class: "buttons" }
const _hoisted_59 = {
  key: 0,
  class: "section-aside"
}
const _hoisted_60 = { class: "contact-person" }
const _hoisted_61 = { class: "contact-person__photo" }
const _hoisted_62 = { class: "contact-person__name" }
const _hoisted_63 = { class: "contact-person__function" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = {
  key: 0,
  class: "contact-person__phone"
}
const _hoisted_66 = ["href"]
const _hoisted_67 = {
  key: 1,
  class: "contact-person__email"
}
const _hoisted_68 = ["href"]
const _hoisted_69 = {
  key: 1,
  class: "contact-person__login"
}
const _hoisted_70 = {
  key: 2,
  class: "contact-person__logo"
}
const _hoisted_71 = { class: "contact-person__detail" }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = ["href"]
const _hoisted_74 = ["href"]
const _hoisted_75 = {
  key: 1,
  class: "section-aside"
}
const _hoisted_76 = { class: "virtual-tour" }
const _hoisted_77 = ["src"]
const _hoisted_78 = { class: "virtual-tour" }
const _hoisted_79 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Head = _resolveComponent("Head")!
  const _component_ResizableImage = _resolveComponent("ResizableImage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AdDetailHeader = _resolveComponent("AdDetailHeader")!
  const _component_FixedElement = _resolveComponent("FixedElement")!
  const _component_AdDetailGallery = _resolveComponent("AdDetailGallery")!
  const _component_AdLabels = _resolveComponent("AdLabels")!
  const _component_AdListItemCompare = _resolveComponent("AdListItemCompare")!
  const _component_AdListItemLike = _resolveComponent("AdListItemLike")!
  const _component_AdListItemFavorite = _resolveComponent("AdListItemFavorite")!
  const _component_ReadMore = _resolveComponent("ReadMore")!
  const _component_MapPositionReadonly = _resolveComponent("MapPositionReadonly")!
  const _component_AdShare = _resolveComponent("AdShare")!
  const _component_AdImage = _resolveComponent("AdImage")!
  const _component_Banner = _resolveComponent("Banner")!
  const _component_AdInterestedForm = _resolveComponent("AdInterestedForm")!
  const _component_LoginButton = _resolveComponent("LoginButton")!
  const _component_AdListSimilar = _resolveComponent("AdListSimilar")!
  const _component_AdDeveloperProjectList = _resolveComponent("AdDeveloperProjectList")!
  const _component_AdComplaint = _resolveComponent("AdComplaint")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.ad)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Head, null, {
          default: _withCtx(() => [
            _createElementVNode("title", null, _toDisplayString(_ctx.ad.title), 1),
            _createElementVNode("meta", {
              name: "description",
              content: this.ad.metaDescription
            }, null, 8, _hoisted_2),
            _createElementVNode("meta", {
              property: "og:title",
              content: _ctx.ad.title
            }, null, 8, _hoisted_3),
            _hoisted_4,
            _createElementVNode("meta", {
              property: "og:url",
              content: _ctx.fullUrl
            }, null, 8, _hoisted_5),
            _createElementVNode("meta", {
              property: "og:image",
              content: _ctx.defaultImage
            }, null, 8, _hoisted_6),
            _createElementVNode("meta", {
              property: "og:image:width",
              content: _ctx.ogImageWidth
            }, null, 8, _hoisted_7),
            _createElementVNode("meta", {
              property: "og:image:height",
              content: _ctx.ogImageHeight
            }, null, 8, _hoisted_8),
            _createElementVNode("meta", {
              property: "og:description",
              content: this.ad.metaDescription
            }, null, 8, _hoisted_9)
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          class: _normalizeClass(["estate-detail", _ctx.classByAdType])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["estate-detail__header", { fixed: _ctx.isHeaderFixed }])
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.ad.title), 1),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.address), 1),
                    _hoisted_14,
                    (!_ctx.isPreview)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t('AdDetail.publishDate')) + ": " + _toDisplayString(_ctx.$filters.date(_ctx.ad.publishDate)), 1))
                      : _createCommentVNode("", true),
                    _hoisted_16,
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdDetail.lastChangedDate')) + ": " + _toDisplayString(_ctx.$filters.date(_ctx.ad.lastChangedDate)), 1)
                  ]),
                  (!_ctx.isDeveloperProject)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdDetail.id')) + ": " + _toDisplayString(_ctx.ad.adFrontId), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.isDeveloperProject)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(_component_ResizableImage, {
                        url: _ctx.ad.developerProjectLogoRelativeUrl,
                        height: 90,
                        alt: "logo"
                      }, null, 8, ["url"])
                    ]))
                  : (_ctx.isEstateAgency)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_router_link, {
                              to: { name: 'AdAgentList', params: { urlName: _ctx.ad.estateAgentUrlName } }
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ResizableImage, {
                                  url: _ctx.ad.photoRelativeUrl,
                                  placeholder: "img/no-photo-user.png",
                                  width: 135,
                                  height: 135,
                                  alt: _ctx.ad.fullName
                                }, null, 8, ["url", "alt"])
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _createVNode(_component_router_link, {
                                to: { name: 'AdAgentList', params: { urlName: _ctx.ad.estateAgentUrlName } }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.ad.fullName), 1)
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]),
                            (!_ctx.isEstateAgencyMode)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  _createVNode(_component_router_link, {
                                    to: { name: 'AdAgencyList', params: { urlName: _ctx.ad.estateAgencyUrlName } }
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ResizableImage, {
                                        classes: "estate-agency-logo",
                                        url: _ctx.ad.logoRelativeUrl,
                                        placeholder: "img/no-logo-agency.png",
                                        width: 80,
                                        height: 45,
                                        alt: "agency"
                                      }, null, 8, ["url"])
                                    ]),
                                    _: 1
                                  }, 8, ["to"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
              ])
            ], 512),
            _createVNode(_component_FixedElement, {
              class: "header-bottom",
              ref: "headerBottom",
              fixedClass: _ctx.isPreview ? '' : _ctx.fixedClass,
              threshold: _ctx.$refs.headerTop && _ctx.$refs.headerTop.clientHeight,
              onChange: _ctx.updateFixedStatus
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AdDetailHeader, {
                  ad: _ctx.ad,
                  isPreview: _ctx.isPreview,
                  onInterested: _ctx.scrollToInterestedForm,
                  showParams: _ctx.isPreview ? true : !_ctx.isHeaderFixed
                }, null, 8, ["ad", "isPreview", "onInterested", "showParams"])
              ]),
              _: 1
            }, 8, ["fixedClass", "threshold", "onChange"]),
            (_ctx.$refs.headerBottom && _ctx.isHeaderFixed && !_ctx.isPreview)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  style: _normalizeStyle({ height: _ctx.$refs.headerBottom.$el.clientHeight + 'px' })
                }, null, 4))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_AdDetailGallery, {
                  images: _ctx.ad.images,
                  adGuid: _ctx.ad.adGuid,
                  parentImages: _ctx.ad.parentImages,
                  parentAdGuid: _ctx.ad.parentAdGuid,
                  estateType: _ctx.ad.estateType,
                  estateSubType: _ctx.ad.estateSubType,
                  virtualTourLink: _ctx.ad.virtualTourLink,
                  videoLink: _ctx.ad.videoLink,
                  alt: _ctx.ad.altText,
                  showStreetView: _ctx.showStreetView,
                  onStreetview: _ctx.onStreetView,
                  onVirtualtour: _ctx.onVirtualTour,
                  onVideo: _ctx.onVideo,
                  onNavigate: _ctx.onNavigate
                }, null, 8, ["images", "adGuid", "parentImages", "parentAdGuid", "estateType", "estateSubType", "virtualTourLink", "videoLink", "alt", "showStreetView", "onStreetview", "onVirtualtour", "onVideo", "onNavigate"]),
                _createVNode(_component_AdLabels, {
                  ad: _ctx.ad,
                  isDetail: true
                }, null, 8, ["ad"]),
                (!_ctx.isPreview)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createVNode(_component_AdListItemCompare, {
                        ad: _ctx.ad,
                        isDetail: true
                      }, null, 8, ["ad"]),
                      _createVNode(_component_AdListItemLike, {
                        ad: _ctx.ad,
                        isDetail: true
                      }, null, 8, ["ad"]),
                      _createVNode(_component_AdListItemFavorite, {
                        ad: _ctx.ad,
                        isDetail: true
                      }, null, 8, ["ad"]),
                      _createElementVNode("button", {
                        class: "button button--primary",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollToInterestedForm && _ctx.scrollToInterestedForm(...args)))
                      }, _toDisplayString(_ctx.$t('AdDetail.button-interested')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_ReadMore, {
                    text: _ctx.ad.description,
                    textEn: _ctx.ad.descriptionEn,
                    max: 600,
                    isTranslateEnabled: true,
                    moreText: _ctx.$t('show-more'),
                    lessText: _ctx.$t('show-less'),
                    onTranslate: _ctx.translate
                  }, null, 8, ["text", "textEn", "moreText", "lessText", "onTranslate"])
                ]),
                _createVNode(_component_MapPositionReadonly, {
                  id: "estate-detail-map",
                  class: "map",
                  ref: "map",
                  position: _ctx.position,
                  onInitialized: _ctx.onMapInitialized,
                  streetViewControlEnabled: _ctx.showStreetView
                }, null, 8, ["position", "onInitialized", "streetViewControlEnabled"])
              ]),
              _createElementVNode("aside", _hoisted_33, [
                (!_ctx.isPreview)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createVNode(_component_AdShare, { ad: _ctx.ad }, null, 8, ["ad"]),
                      _createElementVNode("button", {
                        class: "button button--print",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.print && _ctx.print(...args)))
                      }, _toDisplayString(_ctx.$t('AdDetail.button-print')), 1),
                      (_ctx.isLoggedIn)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: _normalizeClass(["button button--watchdog", { 'is-active': _ctx.ad.isWatch }]),
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showWatchDog = !_ctx.showWatchDog))
                          }, _toDisplayString(_ctx.$t('AdDetail.button-watchdog')), 3))
                        : _createCommentVNode("", true),
                      (!_ctx.isEstateAgencyMode)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "button button--report",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showAddComplaintModal = true))
                          }, _toDisplayString(_ctx.$t('AdDetail.button-report')), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showWatchDog)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('AdDetail.watchdog')), 1),
                      _createElementVNode("label", _hoisted_36, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: _ctx.ad.isWatch,
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.watchDog && _ctx.watchDog(...args)))
                        }, null, 8, _hoisted_37),
                        _hoisted_38,
                        _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('AdDetail.watchdog-price-watch')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.ad.hasWeb && !_ctx.isEstateAgencyMode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _createElementVNode("a", {
                        href: _ctx.ad.web,
                        target: "_blank",
                        rel: _ctx.ad.isWebNoFollow ? 'nofollow' : null,
                        class: "button button--primary w-100",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.webClick()))
                      }, [
                        (_ctx.ad.webTitle)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.ad.webTitle), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(_ctx.$t('AdDetail.button-agent-website')), 1)
                            ], 64))
                      ], 8, _hoisted_41),
                      _createElementVNode("span", null, _toDisplayString(_ctx.webDomain), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.ad.virtualTourLink)
                  ? (_openBlock(), _createBlock(_component_AdImage, {
                      key: 3,
                      onClick: _ctx.onVirtualTour,
                      class: "estate-virtual-preview",
                      file: _ctx.firstImage,
                      adGuid: _ctx.ad.adGuid,
                      estateType: _ctx.ad.estateType,
                      estateSubType: _ctx.ad.estateSubType,
                      width: 1100,
                      height: 675,
                      watermark: false,
                      backgroundImage: true
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdDetail.button-virtual-preview')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "file", "adGuid", "estateType", "estateSubType"]))
                  : _createCommentVNode("", true),
                (_ctx.ad.videoLink)
                  ? (_openBlock(), _createBlock(_component_AdImage, {
                      key: 4,
                      onClick: _ctx.onVideo,
                      class: "estate-video-preview",
                      file: _ctx.firstImage,
                      adGuid: _ctx.ad.adGuid,
                      estateType: _ctx.ad.estateType,
                      estateSubType: _ctx.ad.estateSubType,
                      width: 1100,
                      height: 675,
                      watermark: false,
                      backgroundImage: true
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, [
                          _hoisted_42,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('AdDetail.button-video-preview')), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["onClick", "file", "adGuid", "estateType", "estateSubType"]))
                  : _createCommentVNode("", true),
                (_ctx.ad.parentAdId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _createVNode(_component_router_link, {
                        to: { name: 'AdDetail', params: { adFrontId: _ctx.ad.parentAdFrontId } }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ResizableImage, {
                            url: _ctx.ad.developerProjectLogoRelativeUrl,
                            height: 360,
                            alt: "logo"
                          }, null, 8, ["url"])
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_44, [
                  _createVNode(_component_Banner, { type: 3 })
                ])
              ])
            ])
          ]),
          (!_ctx.isPreview && !_ctx.isDeveloperProject)
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    (_ctx.isLoggedIn)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.isEstateAgency)
                            ? (_openBlock(), _createElementBlock("h2", _hoisted_49, _toDisplayString(_ctx.$t('AdDetail.contact-form-agent-title')), 1))
                            : _createCommentVNode("", true),
                          (!_ctx.isEstateAgency && _ctx.ad.phoneNumber)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("h2", null, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('AdDetail.contact-form-person-title')) + " ", 1),
                                  _hoisted_50,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('AdDetail.contact-form-person-subtitle')) + " ", 1),
                                  _createElementVNode("a", {
                                    class: "phone",
                                    href: `tel:${_ctx.ad.phoneNumber}`,
                                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onPhone && _ctx.onPhone(...args)))
                                  }, _toDisplayString(_ctx.ad.phoneNumber), 9, _hoisted_51)
                                ]),
                                _createElementVNode("div", _hoisted_52, [
                                  _createElementVNode("a", {
                                    class: "button button--phone",
                                    href: `tel:${_ctx.ad.phoneNumber}`,
                                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onPhone && _ctx.onPhone(...args)))
                                  }, _toDisplayString(_ctx.$t('AdDetail.contact-form-call')), 9, _hoisted_53),
                                  _createElementVNode("a", {
                                    class: "button button--whatsapp",
                                    href: _ctx.whatsAppUrl,
                                    target: "_blank",
                                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onWhatsApp && _ctx.onWhatsApp(...args)))
                                  }, "WhatsApp", 8, _hoisted_54)
                                ]),
                                _createElementVNode("h2", null, _toDisplayString(_ctx.$t('AdDetail.contact-form-write')), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createElementBlock("h2", {
                          key: 1,
                          innerHTML: _ctx.$t('AdDetail.contact-form-login')
                        }, null, 8, _hoisted_55))
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    (_ctx.isLoggedIn || _ctx.isEstateAgencyMode)
                      ? (_openBlock(), _createBlock(_component_AdInterestedForm, {
                          key: 0,
                          id: "contact-form",
                          adFrontId: _ctx.ad.adFrontId,
                          price: _ctx.ad.price
                        }, null, 8, ["adFrontId", "price"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t('AdDetail.login-message')), 1),
                          _createElementVNode("div", _hoisted_58, [
                            _createVNode(_component_LoginButton, {
                              text: _ctx.$t('AdDetail.button-login'),
                              buttonClass: "button button--primary",
                              ref: "loginButton"
                            }, null, 8, ["text"]),
                            _createVNode(_component_router_link, {
                              to: { name: 'RegistrationAgent' },
                              tag: "button",
                              class: "button button--primary reversed"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('AdDetail.button-register')), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ], 64))
                  ]),
                  (_ctx.isEstateAgency)
                    ? (_openBlock(), _createElementBlock("aside", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                          _createElementVNode("div", _hoisted_61, [
                            _createVNode(_component_router_link, {
                              to: { name: 'AdAgentList', params: { urlName: _ctx.ad.estateAgentUrlName } }
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ResizableImage, {
                                  url: _ctx.ad.photoRelativeUrl,
                                  placeholder: "img/no-photo-user.png",
                                  width: 135,
                                  height: 135,
                                  alt: _ctx.ad.fullName
                                }, null, 8, ["url", "alt"])
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]),
                          _createElementVNode("div", _hoisted_62, [
                            _createVNode(_component_router_link, {
                              to: { name: 'AdAgentList', params: { urlName: _ctx.ad.estateAgentUrlName } }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.ad.fullName), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]),
                          _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.$t('AdDetail.agent-position')), 1),
                          (_ctx.isLoggedIn || _ctx.isEstateAgencyMode)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                (_ctx.ad.phoneNumber)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                      _createElementVNode("a", {
                                        href: `tel:${_ctx.ad.phoneNumber}`,
                                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onPhone && _ctx.onPhone(...args)))
                                      }, _toDisplayString(_ctx.ad.phoneNumber), 9, _hoisted_66)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.ad.email)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                      _createElementVNode("a", {
                                        href: `mailto:${_ctx.ad.email}`
                                      }, _toDisplayString(_ctx.ad.email), 9, _hoisted_68)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.isLoggedIn && !_ctx.isEstateAgencyMode)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                _createVNode(_component_LoginButton, {
                                  text: _ctx.$t('AdDetail.button-show-contact'),
                                  buttonClass: "button button--primary"
                                }, null, 8, ["text"])
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.isEstateAgencyMode)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                _createVNode(_component_router_link, {
                                  to: { name: 'AdAgencyList', params: { urlName: _ctx.ad.estateAgencyUrlName } }
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ResizableImage, {
                                      classes: "estate-agency-logo",
                                      url: _ctx.ad.logoRelativeUrl,
                                      placeholder: "img/no-logo-agency.png",
                                      width: 240,
                                      height: 135,
                                      alt: "agency"
                                    }, null, 8, ["url"])
                                  ]),
                                  _: 1
                                }, 8, ["to"])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_71, [
                            (_ctx.isLoggedIn || _ctx.isEstateAgencyMode)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                  _createElementVNode("a", {
                                    class: "button button--phone",
                                    href: `tel:${_ctx.ad.phoneNumber}`,
                                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onPhone && _ctx.onPhone(...args)))
                                  }, _toDisplayString(_ctx.$t('AdDetail.contact-form-call')), 9, _hoisted_73),
                                  _createElementVNode("a", {
                                    class: "button button--whatsapp",
                                    href: _ctx.whatsAppUrl,
                                    target: "_blank",
                                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onWhatsApp && _ctx.onWhatsApp(...args)))
                                  }, "WhatsApp", 8, _hoisted_74)
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_router_link, {
                              tag: "button",
                              class: "button",
                              to: { name: 'AdAgentList', params: { urlName: _ctx.ad.estateAgentUrlName } }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('AdDetail.button-agent-ads')), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("aside", _hoisted_75, " "))
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isDeveloperProject && !_ctx.isDeveloperProjectEstate)
            ? (_openBlock(), _createBlock(_component_AdListSimilar, {
                key: 1,
                adFrontId: _ctx.adFrontId
              }, null, 8, ["adFrontId"]))
            : _createCommentVNode("", true)
        ], 2),
        (_ctx.isDeveloperProject || _ctx.isDeveloperProjectEstate)
          ? (_openBlock(), _createBlock(_component_AdDeveloperProjectList, {
              key: 0,
              parentAdId: _ctx.isDeveloperProject ? _ctx.ad.adId : _ctx.ad.parentAdId,
              parentAdFrontId: _ctx.isDeveloperProject ? null : _ctx.ad.parentAdFrontId,
              parentAdTitle: _ctx.isDeveloperProject ? null : _ctx.ad.parentTitle,
              moreAdsTitle: _ctx.isDeveloperProjectEstate,
              currentAdId: _ctx.ad.adId,
              maxFloor: _ctx.ad.maxFloor,
              isPublic: true
            }, null, 8, ["parentAdId", "parentAdFrontId", "parentAdTitle", "moreAdsTitle", "currentAdId", "maxFloor"]))
          : _createCommentVNode("", true),
        (_ctx.showAddComplaintModal)
          ? (_openBlock(), _createBlock(_Teleport, {
              key: 1,
              to: "#container"
            }, [
              _createVNode(_component_AdComplaint, {
                adId: _ctx.ad.adId,
                title: _ctx.ad.title,
                adFrontId: _ctx.ad.adFrontId,
                onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showAddComplaintModal = false))
              }, null, 8, ["adId", "title", "adFrontId"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showVirtualTourModal)
          ? (_openBlock(), _createBlock(_Teleport, {
              key: 2,
              to: "#container"
            }, [
              _createVNode(_component_Modal, {
                class: "modal-fullscreen modal-xl",
                onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showVirtualTourModal = false))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("iframe", {
                      src: _ctx.ad.virtualTourLink
                    }, null, 8, _hoisted_77)
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.showVideoModal)
          ? (_openBlock(), _createBlock(_Teleport, {
              key: 3,
              to: "#container"
            }, [
              _createVNode(_component_Modal, {
                class: "modal-fullscreen modal-xl",
                onClose: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showVideoModal = false))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("iframe", {
                      src: _ctx.ad.videoLink
                    }, null, 8, _hoisted_79)
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}